export const environment = {
  production: false,

  // VIEJOS 
  // api: 'https://auth.autenticartuid.com', // old
  // api: 'http://35.188.7.124:3003/vida/admin',
  // api: 'http://34.121.154.209:3003/vida/admin',
  // **********

  // ACTUALES

  // api: 'http://tuidvida-qa.us-east-1.elasticbeanstalk.com/vida/admin'    // QA asd


  api: 'https://api.autenticartuid.com/vida/admin',  // PROD
  // api: 'http://localhost:3003/vida/admin',  //  LOCAL
  
  
  
  
  
  
};
